import router from './router'
import store from './store'
import {CDB_JWT_ACCESS_TOKEN, ERROR} from './common/constants'

const pathNotAuth = [
  'spproject',
  'sp',
  'spevidence'
]

router.beforeEach(async (to, from, next) => {
  console.log(1)
  try {
    if (!store.state.account_type && store.state.auth_status !== ERROR) {
      console.log(2)
      if (!sessionStorage.getItem(CDB_JWT_ACCESS_TOKEN)) {
        console.log(3)
        let path = to.path.split('/')
        console.log(path)
        if (path.length > 1) {
          console.log(5)
          let pathUrl
          if (path[path.length - 1] === 'sp') {
            console.log(6)
            pathUrl = 'sp'
          } else {
            console.log(7, path)
            pathUrl = path[path.length - 2] + path[path.length - 1]
          }
          console.log(pathUrl)
          if (pathNotAuth.includes(pathUrl)) {
            console.log(8)
            let token = to.query.token
            if (!token) {
              console.log(9)
              token = localStorage.getItem(CDB_JWT_ACCESS_TOKEN)
            } else {
              localStorage.setItem(CDB_JWT_ACCESS_TOKEN, token)
              console.log(10)
            }
            sessionStorage.setItem(CDB_JWT_ACCESS_TOKEN, token)
            store.dispatch('getUser').then(() => next()).catch(() => next('/error'))
          } else {
            window.addEventListener('message', function (event) {
              console.log(4)
              sessionStorage.setItem(CDB_JWT_ACCESS_TOKEN, event.data.message)
              store.dispatch('getUser').then(() => next()).catch(() => next('/error'))
            })
          }
        }
      } else {
        console.log(11)
        let path = to.path.split('/')
        console.log(path)
        if (path.length > 1) {
          console.log(5)
          let pathUrl
          if (path[path.length - 1] === 'sp') {
            console.log(6)
            pathUrl = 'sp'
          } else {
            console.log(7, path)
            pathUrl = path[path.length - 2] + path[path.length - 1]
          }
          console.log(pathUrl)
          if (pathNotAuth.includes(pathUrl)) {
            console.log(8)
            let token = to.query.token
            if (!token) {
              console.log(9)
              token = localStorage.getItem(CDB_JWT_ACCESS_TOKEN)
            } else {
              localStorage.setItem(CDB_JWT_ACCESS_TOKEN, token)
              console.log(10)
            }
            sessionStorage.setItem(CDB_JWT_ACCESS_TOKEN, token)
            store.dispatch('getUser').then(() => next()).catch(() => next('/error'))
          } else {
            window.addEventListener('message', function (event) {
              console.log(12)
              if (event.data.message !== sessionStorage.getItem(CDB_JWT_ACCESS_TOKEN)) {
                console.log(13)
                sessionStorage.setItem(CDB_JWT_ACCESS_TOKEN, event.data.message)
                store.dispatch('getUser').then(() => next()).catch(() => next('/error'))
              } else {
                store.dispatch('getUser').then(() => next()).catch(() => next('/error'))
              }
            })
          }
        }
      }
    }
  } catch (error) {
    console.log(error)
    console.log(error.message)
  }
})



// WEBPACK FOOTER //
// ./src/permission.js